export default __webpack_public_path__ + "img/spoticar-logo.c9fd7219.png";